import { brandAssets, deliveryAssets, hijabDeliveryAssets } from "@talk-asset-catalog";
import { talkBrand } from "./brand";

export const ROSTER_ASSET_KEYS = [
  "azure-fan",
  "violet-shadow",
  "obsidian-blood",
  "rose-thorn",
  "crimson-chainblade",
  "ivory-frost",
  "jade-serpent",
  "golden-sun",
  "silver-moonblade",
  "copper-arena",
  "cobalt-storm",
  "inferno-twinblade",
] as const;

export type RosterAssetKey = (typeof ROSTER_ASSET_KEYS)[number];

const ctfRosterLabels: Record<RosterAssetKey, string> = {
  "azure-fan": "Azure War-Fan Assassin",
  "violet-shadow": "Violet Shadow Dancer",
  "obsidian-blood": "Obsidian Blood-Mage",
  "rose-thorn": "Rose Thorn Assassin",
  "crimson-chainblade": "Crimson Chainblade Duelist",
  "ivory-frost": "Ivory Frost Huntress",
  "jade-serpent": "Jade Serpent Adept",
  "golden-sun": "Golden Sun Champion",
  "silver-moonblade": "Silver Moonblade Dancer",
  "copper-arena": "Copper Arena Brawler",
  "cobalt-storm": "Cobalt Storm Monk",
  "inferno-twinblade": "Inferno Twinblade Rebel",
};

const rosterLabels: Record<RosterAssetKey, string> = Object.fromEntries(
  ROSTER_ASSET_KEYS.map((key, index) => [key, talkBrand.rosterLabels[index] ?? ctfRosterLabels[key]]),
) as Record<RosterAssetKey, string>;
const rosterAssetKeys = new Set<string>(ROSTER_ASSET_KEYS);

export const talkAssets = { ...brandAssets, roster: deliveryAssets, hijabRoster: hijabDeliveryAssets };

export function isRosterAssetKey(value: unknown): value is RosterAssetKey {
  return typeof value === "string" && rosterAssetKeys.has(value);
}

export function rosterAsset(assetKey: unknown, haramMode = false): string | undefined {
  if (!isRosterAssetKey(assetKey)) return undefined;
  const suffix = `/arena-roster/${assetKey}/${haramMode ? "avatar-hijab-v1.webp" : "avatar.webp"}`;
  const assets = haramMode ? hijabDeliveryAssets : deliveryAssets;
  return Object.entries(assets).find(([path]) => path.endsWith(suffix))?.[1];
}

export const talkRoster = ROSTER_ASSET_KEYS.map((key) => ({
  key,
  label: rosterLabels[key],
  avatarUrl: rosterAsset(key) ?? "",
  hijabAvatarUrl: rosterAsset(key, true) ?? "",
}));
